/**
 * Search box toggle functionality
 *
 * @package PPD
 * @since   1.0.0
 */

import $ from "jquery";
import { scrollToEl } from "../global/helpers";

// Make the actual dropdowns function how we need.
function filterDropDowns() {
	$(".sex-dropdown__trigger").on("click", () => {
		$(".sex-dropdown").toggleClass("open");
	});
	$(".location-dropdown__trigger").on("click", () => {
		$(".location-dropdown").toggleClass("open");
	});
	$(".study-dropdown__trigger").on("click", () => {
		$(".study-dropdown").toggleClass("open");
	});
	$(".sort-dropdown__trigger").on("click", () => {
		$(".sort-dropdown").toggleClass("open");
	});
	$(".status-dropdown__trigger").on("click", () => {
		$(".status-dropdown").toggleClass("open");
	});
}

window.addEventListener("load", filterDropDowns);

// set up the bmi calculator stuff rather than have that sitting in the block itself.
function bmiFilter() {
	$(".bmi_filter .bmi_filter_input, .bmi_filter i").on("click", () => {
		$(".bmi-calc-filter").toggleClass("active");
	});
	$(".bmi_filter .bmi-calc-button").on("click", () => {
		calculateBMI();
	});
}

function calculateBMI() {
	var height_feet = eval(document.form1.feet.value);
	if (height_feet != undefined) {
		$("input#feet").removeClass("bmi-error");
	} else {
		$("input#feet").addClass("bmi-error");
	}
	var height_inches = eval(document.form1.inches.value);
	if (height_inches != undefined) {
		$("input#inches").removeClass("bmi-error");
	} else {
		$("input#inches").addClass("bmi-error");
	}
	var pounds = eval(document.form1.weight.value);
	if (pounds != undefined) {
		$("input#weight").removeClass("bmi-error");
	} else {
		$("input#weight").addClass("bmi-error");
	}

	if (
		height_feet != undefined &&
		pounds != undefined &&
		height_inches != undefined
	) {
		$(".bmi_filter .bmi-calc-filter").removeClass("bmi-error");
		var height = height_feet * 12 + height_inches;
		var bmi = (pounds * 703) / (height * height);
		document.getElementById("formbmi").textContent = custRound(bmi, 1);
		document.getElementById("bmi").value = custRound(bmi, 1);
		jQuery("#bmi").trigger("change");
		$(".bmi_filter .bmi-calc-result").toggleClass("calculated");
	} else {
		$(".bmi_filter .bmi-calc-filter").addClass("bmi-error");
		$(".bmi_filter .bmi-calc-result").removeClass("calculated");
	}
}

function custRound(x, places) {
	return Math.round(x * Math.pow(10, places)) / Math.pow(10, places);
}

// Mobile button to toggle the filters open or closed.
function mobileFilterButton() {
	$(".mobile-filter-button, .filter-header i, .filter-footer .show-results").on(
		"click",
		() => {
			$(".filter-list").toggleClass("mobile-flex");
			$(".bg-white").toggleClass("mobile-z-index");
		}
	);
	$(".filter-header i, .filter-footer .show-results").on(
		"click",
		() => {
			setTimeout(() => {
				scrollToEl($("#results-and-pagination-container"), 250);
			}, 250);
		}
	);
}

window.addEventListener("load", mobileFilterButton);

(function ($) {
	// Global variables.
	var listingContainer = $(".em-filterable-trials .result-list");
	var filterContainer = $(".filter-container");
	var filterDetails = $(".filter-details .filter-details-found");

	var pagination = document.querySelector(
		".em-filterable-trials .pagination .page-numbers-container"
	);
	var paginationPrev = document.querySelector(".pagination-prev");
	var paginationNext = document.querySelector(".pagination-next");

	var statusDropdown = $(".status-dropdown__list li");
	var selectedStatus = "status_all";

	var sortDropdown = $(".sort-dropdown__list li");
	var selectedSort = "start_date";
	var selectedSortOrder = "ASC";
	var compensationSortOrder = "DESC";

	var search = document.querySelector("#blog-search-input");
	var prevSearch = "";
	var trialAgeFilter = $(".age_filter");
	var trialBMIFilter = $(".bmi_filter .bmi_filter_input");
	var trialSexFilter = $(".sex-dropdown__list li");
	var trialLocationFilter = $(".location-dropdown__list li");
	var trialStudyFilter = $(".study-dropdown__list li");

	var selectedAgeFilter = [];
	var selectedBMIFilter = [];
	var selectedTrialSexFilter = [];
	var selectedTrialLocationFilter = [];
	var selectedStudyFilter = [];

	var sessionTrialAgeFilter = [];
	var sessionTrialBMIFilter = [];
	var sessionTrialSexFilter = [];
	var sessionTrialLocationFilter = [];
	var sessionTrialStudyFilter = [];

	var initFilterableTrials = function () {
		var canBeLoaded = true;
		// Update the posts within the listing container, based on results from the REST API.
		var updateResults = function (results) {
			listingContainer.empty();
			for (var i = 0; i < results.length; i++) {
				var result = results[i];
				var requirements = "";
				var start_date = result.start_date;
				var tooltip_dates = result.tooltip_dates;
				var sex_icons = "";
				var formatted_bmi = "";
				var formatted_age = "";
				var commitmentLabel = result.commit_days + " Nights";
				// Formatting for requirements and descriptors.
				if (result.requirements != null && result.requirements != false) {
					result.requirements.forEach((req) => {
						requirements +=
							'<div class="trial-requirement">' +
							"<span>" +
							req.name +
							"</span>";
						if (
							result.descriptors != null &&
							result.descriptors != false &&
							result.descriptors[req.term_id] != null &&
							result.descriptors[req.term_id].length > 0
						) {
							requirements +=
								'<button class="ppdbtn btn-tooltip">' +
								'<span class="icon-me-question-circle"></span>' +
								"</button>" +
								'<div class="trial-requirement-details">' +
								result.descriptors[req.term_id] +
								"</div>";
						}
						requirements += "</div>";
					});
				}

				// Formatting flexible start date items as such.
				if (result.is_flexible === "yes") {
					start_date = "Flexible";
					tooltip_dates = "Flexible";
				}

				// Formatting age options to display more nicely.
				if (
					result.age_max === null ||
					result.exclude_upper_age_limit === true
				) {
					formatted_age = result.age_min + "+";
				} else {
					formatted_age = result.age_min + "–" + result.age_max;
				}

				// Formatting bmi options to display more nicely.
				if (
					result.bmi_min === null ||
					result.bmi_min <= 0 ||
					result.bmi_max === null ||
					result.bmi_max <= 0
				) {
					formatted_bmi = "N/A";
				} else {
					formatted_bmi = result.bmi_min + "–" + result.bmi_max;
				}

				// Potentially changing the commitment label based on the new label field.

				if(result.commitment_label !== null){
					commitmentLabel = result.commitment_label;
				}

				// Adding the appropriate sex icons to the display, should only appear if chosen.
				if (result.sex !== null) {
					if (
						result.sex.indexOf("male") != -1 ||
						result.sex.indexOf("male-v") != -1
					) {
						sex_icons += '<span class="icon-me-male"></span>';
					}
					if (
						result.sex.indexOf("female") != -1 ||
						result.sex.indexOf("female-ncb") != -1
					) {
						sex_icons += '<span class="icon-me-female"></span>';
					}
				}

				var resultHTML =
					'<div id="' +
					result.trial_id +
					'" class="result-item ' +
					result.location +
					'">' +
					'<div class="result-requirements-cell">' + // Start requirements.
					'<div class="trial-requirements-title">Requirements:</div>' +
					requirements +
					'<div class="trial-box-indicator ' +
					result.trial_status.toLowerCase() +
					'"><i class="' +
					result.trial_status_icon +
					'"></i> '+
					result.trial_status +
					'</div>' +
					'<div class="trial-box-id">' +
					result.trial_id +
					"</div>" +
					"</div>" + // End requirements.
					'<div class="result-age-cell trial-box">' + // Start age range block.
					"<div>" +
					'<div class="trial-box-title">Age</div>' +
					'<div class="trial-box-value">' +
					"<span> " +
					formatted_age +
					" </span>" +
					"</div>" +
					"</div>" +
					"</div>" + // End age range block.
					'<div class="result-gender-cell trial-box">' + // Start sex block.
					"<div>" +
					'<div class="trial-box-title">Sex</div>' +
					'<div class="trial-box-value">' +
					'<div class="gender-icons"> ' +
					sex_icons +
					" </div>" +
					"</div>" +
					"</div>" +
					"</div>" + // End sex block.
					'<div class="result-bmi-cell trial-box">' + // Start bmi block.
					"<div>" +
					'<div class="trial-box-title">BMI (kg/m²)</div>' +
					'<div class="trial-box-value">' +
					"<span> " +
					formatted_bmi +
					" </span>" +
					"</div>" +
					"</div>" +
					"</div>" + // End bmi block.
					'<div class="result-start-date-cell trial-box tooltip-hidden">' + // Start date block, conditional piece if flexible.
					"<div>" +
					'<div class="trial-box-title">Start Date</div>' +
					'<div class="trial-box-value">' +
					"<span> " +
					start_date +
					" </span>" +
					"</div>" +
					"</div>";
				resultHTML +=
					"</div>" + // End date block.
					'<div class="result-time-commitment-cell trial-box tooltip-hidden">' + // Start commitments section.
					"<div>" +
					'<div class="trial-box-title">Commitment</div>' +
					'<div class="trial-box-value" style="position: relative;">' +
					"<span>"+ commitmentLabel+"</span>" +
					"</div>" +
					"</div>" +
					'<div class="trial-tooltip-container">' +
					'<button class="ppdbtn btn-tooltip" aria-label="commitment-information">' +
					'<span class="icon-me-question-circle"></span>' +
					"</button>" +
					'<div class="time-commitment-details">' +
					'<div class="details-left ppd-dates-name">Dates:</div>' +
					'<div class="details-right ppd-dates-value">' +
					tooltip_dates +
					"</div>" +
					'<div class="details-left ppd-facility-name">PPD Facility:</div>' +
					'<div class="details-right ppd-facility-value">' +
					result.time_commitment.ppd_facility +
					" Nights</div>" +
					'<div class="details-left outpatient-name">Outpatient:</div>' +
					'<div class="details-right outpatient-value">' +
					result.time_commitment.outpatient +
					" Visits</div>" +
					'<div class="details-left phone-calls-name">Phone Calls:</div>' +
					'<div class="details-right phone-calls-value">' +
					result.time_commitment.phone_calls +
					" Calls</div>" +
					'<div class="details-left approx-time-name">Approx. Time:</div>' +
					'<div class="details-right approx-time-value">' +
					result.time_commitment.approximate_time +
					" Days</div>" +
					"</div>" +
					"</div>" +
					"</div>" +
					'<div class="result-compensation-cell trial-box">' +
					"<div>" +
					'<div class="trial-box-title">Compensation</div>' +
					'<div class="trial-box-value">' +
					result.compensation +
					"</div>" +
					"</div>" +
					"</div>" +
					'<div class="result-actions-cell">' +
					'<a href="' +
					result.landing_page +
					'" class="ppdbtn btn-result-learn-more">Learn More</a>' +
					"</div>" +
					"</div>";
				$(resultHTML).appendTo(listingContainer);
			}
		};

		// Updates the clickable content filters at the top of the page, when a filter is applied to the results.
		var updateFilterListing = function (data) {
			Object.keys(data).forEach(function (enabledFilter) {
				if (
					Array.isArray(data[enabledFilter]) &&
					data[enabledFilter].length > 0
				) {
					data[enabledFilter].forEach(function (filter) {
						var extraClass = "";

						if (enabledFilter == "age") {
							extraClass += "enabled-age-filter";
						} else if (enabledFilter == "bmi") {
							extraClass += "enabled-bmi-filter";
						} else if (enabledFilter == "sex") {
							extraClass += "enabled-sex-filter";
						} else if (enabledFilter == "location") {
							extraClass += "enabled-location-filter";
						} else if (enabledFilter == "studies_of_interest") {
							extraClass += "enabled-study-filter";
						}
						if (!filterContainer[0].textContent.includes(filter)) {
							$(".filter-container .clear-all").remove();
							filterContainer.append(
								'<span class="enabled-filter ' +
									extraClass +
									'">' +
									filter +
									'<i class="fa-solid fa-xmark" aria-hidden="true"></i></span>' +
									'<span id="clear-filters" class="clear-all">Clear All</span>'
							);
						}
					});
				}
			});

			if (
				data.search &&
				!filterContainer[0].textContent.includes(data.search)
			) {
				filterContainer.append(
					'<span class="enabled-filter">' +
						data.search +
						' <i class="fa-solid fa-xmark" aria-hidden="true"></i></span>'
				);
			}

			if (filterContainer[0].children.length === 0) {
				$(".saved-filters").css({ display: "none" });
			} else {
				$(".saved-filters").css({ display: "block" });
			}
		};

		// Helper function to hold the enabled filters.
		var getResourceFilters = function () {
			var filters = {
				age: selectedAgeFilter,
				bmi: selectedBMIFilter,
				sex: selectedTrialSexFilter,
				location: selectedTrialLocationFilter,
				studies_of_interest: selectedStudyFilter,
				sort_by: selectedSort,
				sort_order: selectedSortOrder,
				trial_status: selectedStatus,
			};

			return filters;
		};

		// Returns the parameters used to query the REST API.
		var getSearchParams = function () {
			var searchInput = search != undefined ? search.value : null;
			var filters = getResourceFilters();

			// Age filter.
			var ageVal = [];
			var ageName = [];

			// BMI filter.
			var bmiVal = [];
			var bmiName = [];

			// Sex filter.
			var sexVal = [];
			var sexName = [];

			// Location filter.
			var locationVal = [];
			var locationName = [];

			// Studies filter.
			var studyVal = [];
			var studyName = [];

			if (filters.age.checked !== "" && filters.age.name !== undefined) {
				ageVal.push(filters.age.checked);
				ageName.push("Age " + filters.age.checked);
			}

			if (filters.bmi.checked !== "" && filters.bmi.name !== undefined) {
				bmiVal.push(filters.bmi.checked);
				bmiName.push("BMI " + filters.bmi.checked);
			}

			if (filters.sex.checked !== undefined && filters.sex.name !== undefined) {
				sexVal.push(filters.sex.checked);
				sexName.push(filters.sex.name);
			}

			Object.keys(filters.location).forEach(function (key) {
				locationVal.push(filters.location[key].checked);
				locationName.push(filters.location[key].name);
			});

			Object.keys(filters.studies_of_interest).forEach(function (key) {
				studyVal.push(filters.studies_of_interest[key].checked);
				studyName.push(filters.studies_of_interest[key].name);
			});

			var locationValJoined = locationVal.join(",");
			var studyValJoined = studyVal.join(",");

			// Data: the value of each of the selected options, used in searching for resources.
			var data = {
				search: searchInput,
			};
			data.age = ageVal;
			data.bmi = bmiVal;
			data.sex = sexVal;
			if (locationValJoined) data.location = locationValJoined;
			if (studyValJoined) data.studies_of_interest = studyValJoined;

			data.trial_status = selectedStatus;

			data.sort_by = selectedSort;

			// Compensation uses a custom "sortOrder" variable to handle a different order for trials on load.
			if ("compensation" === data.sort_by) {
				data.sort_order = compensationSortOrder;

				if (data.sort_order === "DESC") {
					// Forces the sort order icons to swap to keep inline with design.
					$(".fa-arrow-up-short-wide")
						.removeClass("sort-visible")
						.addClass("sort-hidden");
					$(".fa-arrow-down-wide-short")
						.removeClass("sort-hidden")
						.addClass("sort-visible");
				}
			} else {
				data.sort_order = selectedSortOrder;
			}

			// Names: the filter-friendly name of the value for the filter listings.
			var names = {
				search: searchInput,
				age: ageName,
				bmi: bmiName,
				sex: sexName,
				location: locationName,
				studies_of_interest: studyName,
			};

			updateFilterListing(names);

			// Storing the old search value for comparison if the user searches for resources again.
			//prevSearch = search.value;

			return data;
		};

		// Updates the pagination at the bottom of the page, based on the number of results.
		var updatePagination = function (data, pageNumber) {
			if (data.length >= 1 || data !== "null") {
				var maxPages = parseInt(data.totalPages);
				if (maxPages === 0 || maxPages === 1) {
					$(pagination).html("");
					$(paginationPrev).html("");
					$(paginationNext).html("");
				} else {
					var paginationHTML = "";
					var previous_page = "";
					var next_page = "";

					var currentPage = parseInt(pageNumber ? pageNumber : 1);

					// Previous Link.
					for (var i = 1; i <= maxPages; i++) {
						if (1 != currentPage && maxPages > 1 && 0 != i - 1) {
							previous_page =
								'<span class="prev page-numbers ajax-pagination" data-page="' +
								(currentPage - 1) +
								'"><i class="fa fa-angle-left" aria-hidden="true"></i></span>';
						}
					}

					// Link to the first page of results.
					if (currentPage != 1) {
						paginationHTML +=
							'<span class="page-numbers ajax-pagination ' +
							(1 === currentPage ? "current" : "") +
							'" data-page="' +
							1 +
							'">' +
							1 +
							"</span>";
					}

					// ... Split between page numbers.
					if (currentPage - 2 >= 2) {
						paginationHTML +=
							'<span class="page-numbers ajax-pagination">...</span>';
					}

					// Loads the two previous pages before the current page.
					for (i = currentPage - 2; i < currentPage; i++) {
						if (i > 1 && i > currentPage - 2) {
							paginationHTML +=
								'<span class="page-numbers ajax-pagination ' +
								(i === currentPage ? "current" : "") +
								'" data-page="' +
								i +
								'">' +
								i +
								"</span>";
						}
					}

					// Loads the next two pages after the current page.
					for (i = currentPage; i <= currentPage + 2; i++) {
						if (i <= maxPages) {
							if (i !== maxPages) {
								paginationHTML +=
									'<span class="page-numbers ajax-pagination ' +
									(i === currentPage ? "current" : "") +
									'" data-page="' +
									i +
									'">' +
									i +
									"</span>";
							}
						}
					}

					// ... Split between page numbers.
					if (currentPage + 3 != maxPages && currentPage + 3 < maxPages) {
						paginationHTML +=
							'<span class="page-numbers ajax-pagination">...</span>';
					}

					// Link to the last page of results.
					paginationHTML +=
						'<span class="page-numbers ajax-pagination ' +
						(maxPages === currentPage ? "current" : "") +
						'" data-page="' +
						maxPages +
						'">' +
						maxPages +
						"</span>";

					// Next page link.
					for (i = 1; i <= maxPages; i++) {
						if (i >= 2 && maxPages > 1 && currentPage != maxPages) {
							next_page =
								'<span class="next page-numbers ajax-pagination" data-page="' +
								(currentPage + 1) +
								'"><i class="fa fa-angle-right" aria-hidden="true"></i></span>';
						}
					}

					$(pagination).html(paginationHTML);
					$(paginationPrev).html(previous_page);
					$(paginationNext).html(next_page);
				}
			}
		};

		// Function to sort data based on specified parameters
		var sortData = function (params, results) {
			var sortedData = results.sort((a, b) => {
				// Determine the sorting order multiplier based on the sort_order parameter.
				const sortOrderMultiplier = params.sort_order === "ASC" ? 1 : -1;

				switch (params.sort_by) {
					case "start_date":
						// Confirm both lisitings hve a start date.
						var hasStartDateA = Boolean(a.start_date);
						var hasStartDateB = Boolean(b.start_date);

						if (hasStartDateA === hasStartDateB) {
							// If both listings have a start date, prioritize the non-flexible listings over the flexible listings in the result order.
							var isFlexibleA = a.is_flexible === "yes";
							var isFlexibleB = b.is_flexible === "yes";

							// Forces the sort order multiplier to be 1, so flexible listings are always at the bottom of the results.
							return 1 * (isFlexibleA - isFlexibleB);
						}

						return sortOrderMultiplier * (hasStartDateA ? -1 : 1);

					case "location":
						// Use localeCompare because locations are strings.
						var itemComparison = a[params.sort_by].localeCompare(
							b[params.sort_by]
						);

						if (itemComparison === 0) {
							var isFlexibleA = a.is_flexible === "yes";
							var isFlexibleB = b.is_flexible === "yes";
							return sortOrderMultiplier * (isFlexibleA - isFlexibleB);
						}

						return sortOrderMultiplier * itemComparison;
					case "commit_days":
					case "compensation":
						// Compare the numeric values to sort results.
						var valueA = a[params.sort_by];
						var valueB = b[params.sort_by];

						if (valueA !== valueB) {
							return sortOrderMultiplier * (valueA - valueB);
						}

						// If results have the same location, prioritize non-flexible listings over flexible listings.
						if (sortOrderMultiplier === 0) {
							var isFlexibleA = a.is_flexible === "yes";
							var isFlexibleB = b.is_flexible === "yes";
							return isFlexibleA - isFlexibleB;
						}

					default:
						// If sort_by parameter is not recognized, no change in order.
						return 0;
				}
			});
			return sortedData;
		};

		// Queries the REST API using the search parameters above and returns results on success.
		var filterTrials = function (data) {
			if (canBeLoaded === true) {
				var protocol = document.location.protocol;
				var root = document.location.hostname;

				$.ajax({
					url:
						protocol +
						"//" +
						root +
						"/participate-in-clinical-trial/wp-json/meandppd/v2/trials?per_page=25", // participate-in-clinical-trial for live, meandppd for staging
					data: data,
					type: "GET",
					dataType: "json",
					timeout: 10000,
					error: function () {
						listingContainer.html(
							'<div class="results-message">No clinical trials found.</div>'
						);
						$(pagination).html("");
						$(paginationPrev).html("");
						$(paginationNext).html("");
						canBeLoaded = true;
					},
					success: function (results, status, xhr) {
						if (null != results.response) {
							var sortedData = sortData(results.params, results.response);
							listingContainer.html(
								'<div class="results-message">Loading clinical trials...</div>'
							);
							filterDetails.text("");
							setTimeout(function () {
								filterDetails.text(
									results.totalPosts + " Clinical Trials Found"
								);
								updateResults(sortedData);
								updatePagination(results, results.page);
							}, 500);
							canBeLoaded = true;
						} else {
							listingContainer.html(
								'<div class="results-message">No clinical trials found.</div>'
							);
							filterDetails.text("");
							$(pagination).html("");
							$(paginationPrev).html("");
							$(paginationNext).html("");
							canBeLoaded = true;
						}
					},
				});
			}
		};

		// Fixes the radio button strangeness where it double clicks, still want to trigger the single click here.
		$('.sex-dropdown__list li input[type="radio"]').on(
			"mousedown",
			function (e) {
				e.preventDefault();
				this.parentElement.click();
			}
		);

		// Fixes the checkbox not being clickable, still want to trigger the single click here.
		$(
			'.location-dropdown__list li input[type="checkbox"], .study-dropdown__list li input[type="checkbox"]'
		).on("mousedown", function (e) {
			e.preventDefault();
			this.parentElement.click();
			return false;
		});

		// Adds the selected options in each of the drop downs as content filters on select.
		// Age filter, cares about user pressing enter or unfocusing the input.
		trialAgeFilter.on(
			"keyup",
			delay(function () {
				var input = $(this);
				var enabled = { name: "age", checked: input.val() };
				var data;

				if (input.val() === 0 || input.val() === "") {
					var enabledFilters = $(".enabled-filter.enabled-age-filter");

					enabledFilters.each(function () {
						$(this).remove();
					});

					if (filterContainer[0].children.length === 0) {
						$(".saved-filters").css({ display: "none" });
					}

					if (input.val() !== 0 || input.val() !== "") {
						selectedAgeFilter = enabled;
					} else {
						selectedAgeFilter = [];
					}

					data = getSearchParams();
					filterTrials(data);
				} else {
					sessionTrialAgeFilter.push($(this).val());
					window.sessionStorage.setItem(
						"trialAgeFilter",
						JSON.stringify(sessionTrialAgeFilter)
					);

					var enabledFilters = $(".enabled-filter.enabled-age-filter");

					enabledFilters.each(function () {
						$(this).remove();
					});

					if (input.val() !== 0 || input.val() !== "") {
						selectedAgeFilter = enabled;
					} else {
						selectedAgeFilter = [];
					}

					data = getSearchParams();
					filterTrials(data);
				}
			}, 500)
		);
		// BMI filter, normal functionality further down here but this cares about the same things as age, AND the calculator.
		trialBMIFilter.on(
			"keyup change",
			delay(function () {
				var input = $(this);
				var enabled = { name: "bmi", checked: input.val() };
				var data;

				if (input.val() === 0 || input.val() === "") {
					var enabledFilters = $(".enabled-filter.enabled-bmi-filter");

					enabledFilters.each(function () {
						$(this).remove();
					});

					if (filterContainer[0].children.length === 0) {
						$(".saved-filters").css({ display: "none" });
					}

					if (input.val() !== 0 || input.val() !== "") {
						selectedBMIFilter = enabled;
					} else {
						selectedBMIFilter = [];
					}

					data = getSearchParams();
					filterTrials(data);
				} else {
					sessionTrialBMIFilter.push($(this).val());
					window.sessionStorage.setItem(
						"trialAgeFilter",
						JSON.stringify(sessionTrialBMIFilter)
					);

					var enabledFilters = $(".enabled-filter.enabled-bmi-filter");

					enabledFilters.each(function () {
						$(this).remove();
					});

					if (input.val() !== 0 || input.val() !== "") {
						selectedBMIFilter = enabled;
					} else {
						selectedBMIFilter = [];
					}

					data = getSearchParams();
					filterTrials(data);
				}
			}, 500)
		);
		// Sex filter, only one at a time b/c radio buttons.
		trialSexFilter.on("click", function () {
			var input = $(this).find('input[type="radio"]');
			var checked = input.val();
			var name = input.attr("id");
			var enabled = { name: name, checked: checked };
			var data;

			if (input.prop("checked") === true) {
				input.prop("checked", false);
				var removed = name;
				var enabledFilters = $(".enabled-filter");

				enabledFilters.each(function () {
					if (this.textContent === removed) {
						$(this).remove();
					}
				});

				if (filterContainer[0].children.length === 0) {
					$(".saved-filters").css({ display: "none" });
				}

				if (input.is(":checked")) {
					selectedTrialSexFilter = enabled;
				} else {
					selectedTrialSexFilter = [];
				}

				data = getSearchParams();
				filterTrials(data);
			} else {
				sessionTrialSexFilter.push($(this).attr("data-sex-slug"));
				window.sessionStorage.setItem(
					"trialSexFilter",
					JSON.stringify(sessionTrialSexFilter)
				);

				var activeSexFilters = $(".enabled-filter.enabled-sex-filter");
				activeSexFilters.each(function () {
					$(this).remove();
				});

				input.prop("checked", true);
				if (input.is(":checked")) {
					selectedTrialSexFilter = enabled;
				} else {
					selectedTrialSexFilter = [];
				}

				data = getSearchParams();
				filterTrials(data);
			}
		});
		// Location filter, starts with "all" selected and then on clicking filters removes that and changes content.
		trialLocationFilter.on("click", function () {
			var input = $(this).find('input[type="checkbox"]');
			var checked = input.val();
			var name = input.attr("name");

			var enabled = { name: name, checked: checked };
			var data;
			var canFilter = false;

			if (input.prop("checked") === true && name != "all") {
				input.prop("checked", false);
				var removed = name;
				var enabledFilters = $(".enabled-filter");

				enabledFilters.each(function () {
					if (this.textContent === removed) {
						$(this).remove();
					}
				});

				if (filterContainer[0].children.length === 0) {
					$(".saved-filters").css({ display: "none" });
				}

				if (input.is(":checked")) {
					selectedTrialLocationFilter.push(enabled);
				} else {
					selectedTrialLocationFilter.splice(
						selectedTrialLocationFilter.findIndex(
							(filter) => filter.name === removed
						),
						1
					);
				}

				// This should re-check the "All Locations" checkbox.
				if (name != "all" && selectedTrialLocationFilter.length == 0) {
					$('.location-dropdown__list input[name="all"]').prop("checked", true);
				}
			} else if (name === "all") {
				var input = $(this).find('input[type="checkbox"]');
				var name = input.attr("name");
				var activeLocFilters = $(".enabled-filter.enabled-location-filter");

				activeLocFilters.each(function () {
					$(this).remove();
				});

				$(".location-dropdown__list input").prop("checked", false);
				selectedTrialLocationFilter = [];
				input.prop("checked", true);
			} else {
				// This should uncheck the "All Locations" checkbox.
				if (name != "all") {
					$('.location-dropdown__list input[name="all"]').prop(
						"checked",
						false
					);
				}

				sessionTrialLocationFilter.push($(this).attr("data-type-slug"));
				window.sessionStorage.setItem(
					"trialLocations",
					JSON.stringify(sessionTrialLocationFilter)
				);

				input.prop("checked", true);
				if (input.is(":checked")) {
					selectedTrialLocationFilter.push(enabled);
				} else {
					selectedTrialLocationFilter.splice(
						selectedTrialLocationFilter.findIndex(
							(filter) => filter.name === removed
						),
						1
					);
				}
			}
			setTimeout(function () {
				canFilter = true;
			}, 500);
			setTimeout(function () {
				if ((canFilter = true)) {
					data = getSearchParams();
					filterTrials(data);
				}
			}, 600);
		});
		// Studies filter, same deal as locations filter.
		trialStudyFilter.on("click", function () {
			var input = $(this).find('input[type="checkbox"]');
			var checked = input.val();
			var name = input.attr("name");
			var enabled = { name: name, checked: checked };
			var data;
			var canFilter = false;

			if (input.prop("checked") === true && name != "all") {
				input.prop("checked", false);
				var removed = name;
				var enabledFilters = $(".enabled-filter");

				enabledFilters.each(function () {
					if (this.textContent === removed) {
						$(this).remove();
					}
				});

				if (filterContainer[0].children.length === 0) {
					$(".saved-filters").css({ display: "none" });
				}

				if (input.is(":checked")) {
					selectedStudyFilter.push(enabled);
				} else {
					selectedStudyFilter.splice(
						selectedStudyFilter.findIndex((filter) => filter.name === removed),
						1
					);
				}

				// This should re-check the "All Studies" checkbox.
				if (name != "all" && selectedStudyFilter.length == 0) {
					$('.study-dropdown__list input[name="all"]').prop("checked", true);
				}
			} else if (name === "all") {
				var input = $(this).find('input[type="checkbox"]');
				var name = input.attr("name");
				var activeStudyFilters = $(".enabled-filter.enabled-study-filter");

				activeStudyFilters.each(function () {
					$(this).remove();
				});

				$(".study-dropdown__list input").prop("checked", false);
				selectedStudyFilter = [];
				input.prop("checked", true);
			} else {
				// This should uncheck the "All Studies" checkbox.
				if (name != "all") {
					$('.study-dropdown__list input[name="all"]').prop("checked", false);
				}

				sessionTrialStudyFilter.push($(this).attr("data-type-slug"));
				window.sessionStorage.setItem(
					"studiesOfInterest",
					JSON.stringify(sessionTrialStudyFilter)
				);

				input.prop("checked", true);
				if (input.is(":checked")) {
					selectedStudyFilter.push(enabled);
				} else {
					selectedStudyFilter.splice(
						selectedStudyFilter.findIndex((filter) => filter.name === removed),
						1
					);
				}
			}

			setTimeout(function () {
				canFilter = true;
			}, 500);
			setTimeout(function () {
				if ((canFilter = true)) {
					data = getSearchParams();
					filterTrials(data);
				}
			}, 600);
		});

		// Sorting! We want to show the selected sort in the trigger, hide the option, and then pass the appropriate info to our endpoint.
		sortDropdown.on("click", function () {
			var input = $(this).find('input[type="checkbox"]');
			var name = input.attr("name");
			var data;

			input.prop("checked", true);
			sortDropdown.removeClass("sort-selected");
			$(this).addClass("sort-selected");
			$(".sort-dropdown__trigger span").text($(this).find("label").text());
			$(".sort-dropdown").toggleClass("open");

			selectedSort = name;

			data = getSearchParams();
			filterTrials(data);
		});

		// We want to show the selected trial status in the trigger, hide the option, and then pass the appropriate info to our endpoint.
		statusDropdown.on("click", function () {
			var input = $(this).find('input[type="checkbox"]');
			var name = input.attr("name");
			var data;

			input.prop("checked", true);
			statusDropdown.removeClass("status-selected");
			$(this).addClass("status-selected");
			$(".status-dropdown__trigger span").text($(this).find("label").text());
			$(".status-dropdown").toggleClass("open");

			selectedStatus = name;

			data = getSearchParams();
			filterTrials(data);
		});

		$(document).on("click", ".sort-visible", function () {
			var data;

			$(".sort-hidden").addClass("sort-visible").removeClass("sort-hidden");
			$(this).addClass("sort-hidden").removeClass("sort-visible");

			if ("compensation" === selectedSort) {
				if (compensationSortOrder === "ASC") {
					compensationSortOrder = "DESC";
				} else {
					compensationSortOrder = "ASC";
				}
			} else {
				if (selectedSortOrder === "DESC") {
					selectedSortOrder = "ASC";
				} else {
					selectedSortOrder = "DESC";
				}
			}

			data = getSearchParams();
			filterTrials(data);
		});

		$('input[type="checkbox"], input[type="radio"]').click(function (e) {
			e.preventDefault();
			return false;
		});

		var removeOldSearchFilter = function (prevSearch) {
			$(".enabled-filter").each(function () {
				if (this.innerText === prevSearch) {
					$(this).remove();
				}
			});
		};

		// Main search button.
		$("#search-blog").on("click", function () {
			removeOldSearchFilter(prevSearch);
			var data = getSearchParams();
			filterTrials(data);
		});

		// Submit the search form when a user presses enter.
		$("body").on("keydown", function (e) {
			if (e.keyCode === 13 || e.which === 13) {
				removeOldSearchFilter(prevSearch);
				var data = getSearchParams();
				filterTrials(data);
			}
		});

		// Closes the dropdown container when clicking on something that isn't a dropdown container.
		$(document).on("click", function (e) {
			if ($(".sex-dropdown").hasClass("open")) {
				if (!$(e.target).is(".sex-dropdown, .sex-dropdown *")) {
					$(".sex-dropdown").removeClass("open");
				}
			}

			if ($(".location-dropdown").hasClass("open")) {
				if (!$(e.target).is(".location-dropdown, .location-dropdown *")) {
					$(".location-dropdown").removeClass("open");
				}
			}

			if ($(".study-dropdown").hasClass("open")) {
				if (!$(e.target).is(".study-dropdown, .study-dropdown *")) {
					$(".study-dropdown").removeClass("open");
				}
			}

			if ($(".sort-dropdown").hasClass("open")) {
				if (!$(e.target).is(".sort-dropdown, .sort-dropdown *")) {
					$(".sort-dropdown").removeClass("open");
				}
			}

			if ($(".status-dropdown").hasClass("open")) {
				if (!$(e.target).is(".status-dropdown, .status-dropdown *")) {
					$(".status-dropdown").removeClass("open");
				}
			}

			if ($(".bmi_filter .bmi-calc-filter").hasClass("active")) {
				if (!$(e.target).is(".bmi_filter, .bmi_filter *")) {
					$(".bmi_filter .bmi-calc-filter").removeClass("active");
					$(".bmi_filter .bmi-calc-result").removeClass("calculated");
				}
			}
		});

		// Clears all filters on click, sets all checkboxes to unchecked.
		$(document).on("click", ".clear-all", function () {
			$(".enabled-filter, .filter-container .clear-all").remove();

			selectedAgeFilter = [];
			selectedBMIFilter = [];
			selectedTrialSexFilter = [];
			selectedTrialLocationFilter = [];
			selectedStudyFilter = [];

			$('input[type="checkbox"]').prop("checked", false);
			$('input[name="all"]').prop("checked", true);
			$('input[type="radio"]').prop("checked", false);
			$(".age_filter").val("");
			$(".bmi_filter .bmi_filter_input").val("");

			if (filterContainer[0].children.length === 0) {
				$(".saved-filters").css({ display: "none" });
			}

			var data = getResourceFilters();
			var params = getSearchParams(data);
			filterTrials(params);
		});

		// Removes the enabled filter on click, and updates the results.
		$(document).on("click", ".enabled-filter", function (e) {
			var removed = $(this);
			var removedFilterName = removed.text();

			$('input[name="' + removedFilterName + '"]').prop("checked", false);
			$('input[id="' + removedFilterName + '"]').prop("checked", false);

			if (removed.hasClass("enabled-age-filter")) {
				selectedAgeFilter = [];

				$(".age_filter").val("");

				sessionTrialAgeFilter = [];
				window.sessionStorage.setItem(
					"insightTopics",
					JSON.stringify(sessionTrialAgeFilter)
				);
			}

			if (removed.hasClass("enabled-bmi-filter")) {
				selectedBMIFilter = [];

				$(".bmi_filter_input").val("");

				sessionTrialBMIFilter = [];
				window.sessionStorage.setItem(
					"insightTopics",
					JSON.stringify(sessionTrialBMIFilter)
				);
			}

			if (removed.hasClass("enabled-sex-filter")) {
				selectedTrialSexFilter = [];

				sessionTrialSexFilter = [];
				window.sessionStorage.setItem(
					"insightTopics",
					JSON.stringify(sessionTrialSexFilter)
				);
			}

			if (
				selectedTrialLocationFilter.findIndex(
					(filter) => filter.name === removed.text()
				) !== -1
			) {
				selectedTrialLocationFilter.splice(
					selectedTrialLocationFilter.findIndex(
						(filter) => filter.name === removed.text()
					),
					1
				);

				if (selectedTrialLocationFilter.length == 0) {
					$('.location-dropdown__list input[name="all"]').prop("checked", true);
				}

				var removedSlug = removed.text().toLowerCase().replace(/ /g, "-");
				var index = sessionTrialLocationFilter.indexOf(removedSlug);
				if (index !== -1) {
					sessionTrialLocationFilter.splice(index, 1);
				}
				window.sessionStorage.setItem(
					"insightContentTypes",
					JSON.stringify(sessionTrialLocationFilter)
				);
			}

			if (
				selectedStudyFilter.findIndex(
					(filter) => filter.name === removed.text()
				) !== -1
			) {
				selectedStudyFilter.splice(
					selectedStudyFilter.findIndex(
						(filter) => filter.name === removed.text()
					),
					1
				);

				if (selectedStudyFilter.length == 0) {
					$('.study-dropdown__list input[name="all"]').prop("checked", true);
				}

				var removedSlug = removed.text().toLowerCase().replace(/ /g, "-");
				var index = sessionTrialStudyFilter.indexOf(removedSlug);
				if (index !== -1) {
					sessionTrialStudyFilter.splice(index, 1);
				}

				window.sessionStorage.setItem(
					"insightContentTypes",
					JSON.stringify(sessionTrialStudyFilter)
				);
			}

			var data = getResourceFilters();
			var params = getSearchParams(data);

			if (removed.text() === params.search) {
				params.search = "";
				$(".blog-search input").val("");
				this.remove();
				if (filterContainer[0].children.length === 0) {
					$(".saved-filters").css({ display: "none" });
				} else {
					$(".saved-filters").css({ display: "block" });
				}
			} else {
				removed[0].remove();
				if (
					filterContainer[0].children.length === 0 ||
					filterContainer[0].children.length <= 1
				) {
					$(".saved-filters").css({ display: "none" });
					$('input[name="all"]').prop("checked", true);
					$(".filter-container .clear-all").remove();
				} else {
					$(".saved-filters").css({ display: "block" });
				}
			}

			filterTrials(params);
		});

		// Updates the page content when clicking to the next page.
		$(document).on("click", ".page-numbers.ajax-pagination", function () {
			var data = getSearchParams();
			var paged = $(this).attr("data-page");
			data.page = paged;
			$("html, body").animate({ scrollTop: 300 }, "slow");
			filterTrials(data);
		});

		// Grabs the parameters from the url to autopopulate filters.
		var getUrlParameters = function (name) {
			var reg = new RegExp("[?&]" + name + "=([^&#]*)", "g"),
				matches = [],
				results;

			// Loop through the location to grab all instances of the passed filter.
			while ((results = reg.exec(window.location.href)) !== null) {
				matches.push(results[1]);
			}

			return matches;
		};

		var getFirstLoadFilters = function () {
			var loadCats = getUrlParameters("topic");
			var loadTypes = getUrlParameters("type");

			// Check if the user has already set a topic filter in this session.
			if (
				"insightTopics" in sessionStorage &&
				sessionStorage["insightTopics"].length > 2
			) {
				sessionTrialSexFilter = JSON.parse(
					window.sessionStorage.getItem("insightTopics")
				);
				sessionTrialSexFilter.forEach(function (item, index) {
					loadCats.push(item);
				});
			}

			// Check if the user has already set a content type filter in this session.
			if (
				"insightContentTypes" in sessionStorage &&
				sessionStorage["insightContentTypes"].length > 2
			) {
				sessionTrialLocationFilter = JSON.parse(
					window.sessionStorage.getItem("insightContentTypes")
				);
				sessionTrialLocationFilter.forEach(function (item, index) {
					loadTypes.push(item);
				});
			}

			if (loadCats.length > 0) {
				// Our getUrlParameters function will return an array so we want to loop through.
				loadCats.forEach(function (item, index) {
					// Make a variable to store the input we want to target.
					var input = $('li[data-cat-slug="' + item + '"]').find(
						'input[type="checkbox"]'
					);
					var checked = input.val();
					var name = input.attr("name");
					var enabled = { name: name, checked: checked };

					// Set that variable to true, update the other page globals accordingly.
					input.prop("checked", true);
					if (input.is(":checked")) {
						selectedTrialSexFilter.push(enabled);
					} else {
						selectedTrialSexFilter.splice(
							selectedTrialSexFilter.findIndex(
								(filter) => filter.name === removed
							),
							1
						);
					}
				});
			}
			if (loadTypes.length > 0) {
				// Our getUrlParameters function will return an array so we want to loop through.
				loadTypes.forEach(function (item, index) {
					// Make a variable to store the input we want to target.
					var input = $('li[data-type-slug="' + item + '"]').find(
						'input[type="checkbox"]'
					);
					var checked = input.val();
					var name = input.attr("name");
					if (name === "blog-post") {
						name = "Blog Post";
					}
					var enabled = { name: name, checked: checked };

					// Set that variable to true, update the other page globals accordingly.
					input.prop("checked", true);
					if (input.is(":checked")) {
						selectedTrialLocationFilter.push(enabled);
					} else {
						selectedTrialLocationFilter.splice(
							selectedTrialLocationFilter.findIndex(
								(filter) => filter.name === removed
							),
							1
						);
					}
				});
			}
		};

		// Custom delay handler function that will let us not reload the results every time a key is released.
		function delay(callback, ms) {
			var timer = 0;
			return function () {
				var context = this,
					args = arguments;
				clearTimeout(timer);
				timer = setTimeout(function () {
					callback.apply(context, args);
				}, ms || 0);
			};
		}

		// Updates the page content on load.
		$(document).ready(function () {
			$(".enabled-filter").remove();

			var searchInput = null;
			selectedTrialSexFilter = [];
			selectedTrialLocationFilter = [];

			//$('input[type="checkbox"]').prop("checked", false);

			//getFirstLoadFilters();
			var data = getResourceFilters();
			var params = getSearchParams(data);

			filterTrials(data);
		});
	};

	// To prevent errors on other pages, only run this script on the insights hub page.
	if (document.querySelector(".em-filterable-trials")) {
		document.addEventListener("DOMContentLoaded", initFilterableTrials);
		document.addEventListener("DOMContentLoaded", bmiFilter);
	}
})(jQuery);
